import { jsxs as i, jsx as s, Fragment as ie } from "react/jsx-runtime";
import { clsx as _ } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { forwardRef as oe, useCallback as te } from "react";
import { remCalc as ce } from "../../style/base/index.js";
import { LinkTarget as _e } from "../../types/target-link-types.js";
import { normalizeVideoId as ne } from "../../utils/normalize-video-id.js";
import { RocheUIButton as Ae } from "../button/roche-button.js";
import { RocheUIButtonAppearance as me } from "../button/roche-button-types.js";
import { RocheUIIcon as de } from "../icon/roche-icon.js";
import { RocheUIImage as Ie } from "../image/roche-image.js";
import { RocheUIImageRatio as O, RocheUIImageFit as le } from "../image/roche-image.types.js";
import { RocheUIVideoPlayer as Re } from "../video-player/roche-video-player.js";
import a from "./roche-teaser.module.scss.js";
import { RocheUITeaserIcon as d, RocheUITeaserLayout as e } from "./roche-teaser.types.js";
const he = [
  e.VARIANT_A,
  e.VARIANT_A_WITHOUT_IMAGE,
  e.CARD_A,
  e.VARIANT_B,
  e.VARIANT_B_WITHOUT_IMAGE,
  e.CARD_B,
  e.VARIANT_E,
  e.PUBMED
], pe = [
  e.VARIANT_A,
  e.VARIANT_A_WITHOUT_IMAGE,
  e.CARD_A,
  e.VARIANT_C,
  e.VARIANT_C_WITHOUT_IMAGE,
  e.VARIANT_C_WITHOUT_IMAGE_WITH_DATE,
  e.CARD_C,
  e.PUBMED
], Te = [
  e.VARIANT_A,
  e.VARIANT_B,
  e.VARIANT_C,
  e.VARIANT_D,
  e.VARIANT_E,
  e.VARIANT_E_WITHOUT_DESCRIPTION
], Ne = [e.CARD_A, e.CARD_B, e.CARD_C], Be = /* @__PURE__ */ oe(
  ({
    teaserImage: I,
    teaserVideoId: L,
    teaserImageAlt: l,
    teaserTitle: R,
    teaserDescription: h,
    teaserOverline: n,
    teaserOverlineElement: A,
    teaserUrl: m,
    target: H = _e.SELF,
    isExternalLink: W,
    isDownloadLink: t,
    downloadTranslation: p,
    layout: r,
    secondaryButton: b,
    primaryButtonText: T,
    primaryButtonVisuallyHiddenText: B,
    playLabel: M,
    pauseLabel: x,
    onTeaserClick: N,
    onVideoStateChange: V,
    isSearchResult: G,
    unpublished: P,
    isTeaserInDraft: y,
    teaserAuthorDescription: C,
    slot: f,
    loaded: F,
    forceAlignLeft: S,
    awsServiceBaseUrl: w,
    imageFit: E = le.COVER,
    linkRef: j
  }, k) => {
    const z = n && n !== "" || A, v = ne(L), u = v !== "", X = W ? d.EXTERNAL : t ? d.DOWNLOAD : d.DEFAULT, Y = te(() => {
      const c = r === e.VARIANT_E || r === e.VARIANT_E_WITHOUT_DESCRIPTION, Z = c ? O.VERTICAL : O.HD, ee = pe.includes(r), ae = he.includes(r), se = Te.includes(r), re = Ne.includes(r);
      return {
        isVerticalLayout: c,
        imageRatio: Z,
        hasOverline: ee,
        hasDescription: ae,
        hasImage: se,
        isCard: re
      };
    }, [r]), { hasImage: U, isVerticalLayout: $, imageRatio: g, hasDescription: q, hasOverline: J, isCard: o } = Y(), D = R && /* @__PURE__ */ i(
      "span",
      {
        className: _(a.teaser__title, (G || t) && a["teaser__title--small"]),
        children: [
          R,
          !o && /* @__PURE__ */ s("span", { className: a.teaser__icon, children: /* @__PURE__ */ s(de, { icon: X, height: `${ce(24)}rem` }) })
        ]
      }
    ), K = U && (I || u) && /* @__PURE__ */ i("div", { className: a["teaser__media-container"], children: [
      u ? /* @__PURE__ */ s(
        "div",
        {
          className: _(
            a.teaser__video,
            $ && a["teaser__image--reduced-scale"],
            F && a["teaser__image--loaded"]
          ),
          children: /* @__PURE__ */ s(
            Re,
            {
              awsServiceBaseUrl: w,
              service: "aws",
              videoLoop: !0,
              videoId: v,
              videoFit: E,
              videoRatio: g,
              previewAlt: l ?? "",
              playLabel: M ?? "",
              pauseLabel: x ?? "",
              onVideoStateChange: (c) => {
                V && V(c);
              }
            }
          )
        }
      ) : /* @__PURE__ */ s(
        Ie,
        {
          src: I ?? "",
          alt: l ?? "",
          ratio: g,
          imageFit: E,
          slot: f
        }
      ),
      /* @__PURE__ */ s("div", { className: a["teaser__image-border"] })
    ] }), Q = /* @__PURE__ */ i(ie, { children: [
      K,
      /* @__PURE__ */ s("h3", { className: a.teaser__heading, children: o ? D : /* @__PURE__ */ i(
        "a",
        {
          ref: j,
          target: H,
          href: m,
          download: t || void 0,
          onClick: N,
          className: a["teaser__link-wrapper"],
          children: [
            t && p && /* @__PURE__ */ i("span", { className: a["teaser__visually-hidden"], children: [
              p,
              " "
            ] }),
            D
          ]
        }
      ) }),
      J && z && /* @__PURE__ */ i("span", { className: a.teaser__overline, children: [
        n,
        A && /* @__PURE__ */ s("span", { className: a["teaser__overline-element"], children: A })
      ] }),
      C && /* @__PURE__ */ s("p", { className: "teaser__author-description", children: C }),
      q && h && /* @__PURE__ */ s("p", { className: a.teaser__description, children: h }),
      !U && !o && /* @__PURE__ */ s("div", { className: a.teaser__border }),
      o && /* @__PURE__ */ i(
        "div",
        {
          className: _(
            a["teaser__buttons-wrapper"],
            S && a["teaser__buttons-wrapper--align-left"]
          ),
          children: [
            m && T && /* @__PURE__ */ s(
              Ae,
              {
                href: m,
                appearance: me.SECONDARY,
                text: T,
                visuallyHiddenText: B,
                onClick: N
              }
            ),
            b
          ]
        }
      )
    ] });
    return /* @__PURE__ */ s(
      "div",
      {
        ref: k,
        slot: f,
        className: _(
          a.teaser,
          o && a["teaser--card"],
          P && a["teaser--unpublished"],
          y && a["teaser--in-draft"]
        ),
        children: Q
      }
    );
  }
);
export {
  Be as RocheUITeaser
};
